"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendMixin = exports.appendMixins = exports.hooks = exports.diagnostics = exports.MixinType = void 0;
const feature_1 = require("./feature");
const STSymbol = __importStar(require("./st-symbol"));
const rule_1 = require("../helpers/rule");
const mixin_1 = require("../helpers/mixin");
const deprecation_1 = require("../helpers/deprecation");
const functions_1 = require("../functions");
const parser_1 = require("../parser");
const postcss = __importStar(require("postcss"));
const stylable_assets_1 = require("../stylable-assets");
const stylable_utils_1 = require("../stylable-utils");
const path_1 = require("path");
exports.MixinType = {
    ALL: `-st-mixin`,
    PARTIAL: `-st-partial-mixin`,
};
exports.diagnostics = {
    VALUE_CANNOT_BE_STRING: mixin_1.diagnostics.VALUE_CANNOT_BE_STRING,
    INVALID_NAMED_PARAMS: mixin_1.diagnostics.INVALID_NAMED_PARAMS,
    INVALID_MERGE_OF: stylable_utils_1.INVALID_MERGE_OF,
    PARTIAL_MIXIN_MISSING_ARGUMENTS(type) {
        return `"${exports.MixinType.PARTIAL}" can only be used with override arguments provided, missing overrides on "${type}"`;
    },
    UNKNOWN_MIXIN(name) {
        return `unknown mixin: "${name}"`;
    },
    OVERRIDE_MIXIN(mixinType) {
        return `override ${mixinType} on same rule`;
    },
    FAILED_TO_APPLY_MIXIN(error) {
        return `could not apply mixin: ${error}`;
    },
    JS_MIXIN_NOT_A_FUNC() {
        return `js mixin must be a function`;
    },
    CIRCULAR_MIXIN(circularPaths) {
        return `circular mixin found: ${circularPaths.join(' --> ')}`;
    },
    UNKNOWN_MIXIN_SYMBOL(name) {
        return `cannot mixin unknown symbol "${name}"`;
    },
};
// HOOKS
exports.hooks = (0, feature_1.createFeature)({
    analyzeDeclaration({ context, decl }) {
        (0, deprecation_1.ignoreDeprecationWarn)(() => {
            const parentRule = decl.parent;
            const prevMixins = (parentRule === null || parentRule === void 0 ? void 0 : parentRule.mixins) || [];
            const mixins = collectDeclMixins(context, decl, (mixinSymbolName) => {
                const symbol = STSymbol.get(context.meta, mixinSymbolName);
                return (symbol === null || symbol === void 0 ? void 0 : symbol._kind) === 'import' && !symbol.import.from.match(/.css$/)
                    ? 'args'
                    : 'named';
            }, false /*dont report param signature diagnostics*/, prevMixins);
            if (mixins.length) {
                parentRule.mixins = mixins;
            }
        });
    },
    transformLastPass({ context, ast, transformer, cssVarsMapping, path }) {
        ast.walkRules((rule) => appendMixins(context, transformer, rule, cssVarsMapping, path));
    },
});
// API
function appendMixins(context, transformer, rule, cssPropertyMapping, path = []) {
    const [decls, mixins] = collectRuleMixins(context, rule);
    if (!mixins || mixins.length === 0) {
        return;
    }
    for (const mixin of mixins) {
        appendMixin(context, { transformer, mixDef: mixin, rule, path, cssPropertyMapping });
    }
    for (const mixinDecl of decls) {
        mixinDecl.remove();
    }
}
exports.appendMixins = appendMixins;
function collectRuleMixins(context, rule) {
    let mixins = [];
    const { mainNamespace } = context.getResolvedSymbols(context.meta);
    const decls = [];
    rule.walkDecls((decl) => {
        if (decl.prop === `-st-mixin` || decl.prop === `-st-partial-mixin`) {
            decls.push(decl);
            mixins = collectDeclMixins(context, decl, (mixinSymbolName) => {
                return mainNamespace[mixinSymbolName] === 'js' ? 'args' : 'named';
            }, true /* report param signature diagnostics */, mixins);
        }
    });
    return [decls, mixins];
}
function collectDeclMixins(context, decl, paramSignature, isTransformPhase, previousMixins) {
    const { meta } = context;
    let mixins = [];
    const parser = decl.prop === exports.MixinType.ALL
        ? mixin_1.parseStMixin
        : decl.prop === exports.MixinType.PARTIAL
            ? mixin_1.parseStPartialMixin
            : null;
    if (!parser) {
        return previousMixins || mixins;
    }
    parser(decl, paramSignature, context.diagnostics, isTransformPhase).forEach((mixin) => {
        const mixinRefSymbol = STSymbol.get(meta, mixin.type);
        if (mixinRefSymbol &&
            (mixinRefSymbol._kind === 'import' ||
                mixinRefSymbol._kind === 'class' ||
                mixinRefSymbol._kind === 'element')) {
            if (mixin.partial && Object.keys(mixin.options).length === 0) {
                context.diagnostics.warn(decl, exports.diagnostics.PARTIAL_MIXIN_MISSING_ARGUMENTS(mixin.type), {
                    word: mixin.type,
                });
            }
            const refedMixin = {
                mixin,
                ref: mixinRefSymbol,
            };
            mixins.push(refedMixin);
            if (!isTransformPhase) {
                (0, deprecation_1.ignoreDeprecationWarn)(() => meta.mixins).push(refedMixin);
            }
        }
        else {
            context.diagnostics.warn(decl, exports.diagnostics.UNKNOWN_MIXIN(mixin.type), {
                word: mixin.type,
            });
        }
    });
    if (previousMixins) {
        const partials = previousMixins.filter((r) => r.mixin.partial);
        const nonPartials = previousMixins.filter((r) => !r.mixin.partial);
        const isInPartial = decl.prop === exports.MixinType.PARTIAL;
        if ((partials.length && decl.prop === exports.MixinType.PARTIAL) ||
            (nonPartials.length && decl.prop === exports.MixinType.ALL)) {
            context.diagnostics.warn(decl, exports.diagnostics.OVERRIDE_MIXIN(decl.prop));
        }
        if (partials.length && nonPartials.length) {
            mixins = isInPartial ? nonPartials.concat(mixins) : partials.concat(mixins);
        }
        else if (partials.length) {
            mixins = isInPartial ? mixins : partials.concat(mixins);
        }
        else if (nonPartials.length) {
            mixins = isInPartial ? nonPartials.concat(mixins) : mixins;
        }
    }
    return mixins;
}
function appendMixin(context, config) {
    if (checkRecursive(context, config)) {
        return;
    }
    const resolvedSymbols = context.getResolvedSymbols(context.meta);
    const symbolName = config.mixDef.mixin.type;
    const resolvedType = resolvedSymbols.mainNamespace[symbolName];
    if (resolvedType === `class` || resolvedType === `element`) {
        const resolveChain = resolvedSymbols[resolvedType][symbolName];
        handleCSSMixin(context, config, resolveChain);
        return;
    }
    else if (resolvedType === `js`) {
        const resolvedMixin = resolvedSymbols.js[symbolName];
        if (typeof resolvedMixin.symbol === 'function') {
            try {
                handleJSMixin(context, config, resolvedMixin.symbol);
            }
            catch (e) {
                context.diagnostics.error(config.rule, exports.diagnostics.FAILED_TO_APPLY_MIXIN(String(e)), {
                    word: config.mixDef.mixin.type,
                });
                return;
            }
        }
        else {
            context.diagnostics.error(config.rule, exports.diagnostics.JS_MIXIN_NOT_A_FUNC(), {
                word: config.mixDef.mixin.type,
            });
        }
        return;
    }
    // ToDo: report on unsupported mixed in symbol type
    const mixinDecl = config.mixDef.mixin.originDecl;
    context.diagnostics.error(mixinDecl, exports.diagnostics.UNKNOWN_MIXIN_SYMBOL(mixinDecl.value), {
        word: mixinDecl.value,
    });
}
exports.appendMixin = appendMixin;
function checkRecursive({ meta, diagnostics: report }, { mixDef, path, rule }) {
    const symbolName = mixDef.ref.name === meta.root
        ? mixDef.ref._kind === 'class'
            ? meta.root
            : 'default'
        : mixDef.mixin.type;
    const isRecursive = path.includes(symbolName + ' from ' + meta.source);
    if (isRecursive) {
        // Todo: add test verifying word
        report.warn(rule, exports.diagnostics.CIRCULAR_MIXIN(path), {
            word: symbolName,
        });
        return true;
    }
    return false;
}
function handleJSMixin(context, config, mixinFunction) {
    const stVarOverride = context.evaluator.stVarOverride || {};
    const meta = context.meta;
    const mixDef = config.mixDef;
    const res = mixinFunction(mixDef.mixin.options.map((v) => v.value));
    const mixinRoot = (0, parser_1.cssObjectToAst)(res).root;
    mixinRoot.walkDecls((decl) => {
        if (!(0, stylable_utils_1.isValidDeclaration)(decl)) {
            decl.value = String(decl);
        }
    });
    config.transformer.transformAst(mixinRoot, meta, undefined, stVarOverride, [], true);
    const mixinPath = mixDef.ref.import.request;
    (0, stylable_assets_1.fixRelativeUrls)(mixinRoot, context.resolver.resolvePath((0, path_1.dirname)(meta.source), mixinPath), meta.source);
    (0, stylable_utils_1.mergeRules)(mixinRoot, config.rule, mixDef.mixin.originDecl, context.diagnostics);
}
function handleCSSMixin(context, config, resolveChain) {
    const mixDef = config.mixDef;
    const isPartial = mixDef.mixin.partial;
    const namedArgs = mixDef.mixin.options;
    const overrideKeys = Object.keys(namedArgs);
    if (isPartial && overrideKeys.length === 0) {
        return;
    }
    const roots = [];
    for (const resolved of resolveChain) {
        roots.push(createMixinRootFromCSSResolve(context, config, resolved));
        if (resolved.symbol[`-st-extends`]) {
            break;
        }
    }
    if (roots.length === 1) {
        (0, stylable_utils_1.mergeRules)(roots[0], config.rule, mixDef.mixin.originDecl, config.transformer.diagnostics);
    }
    else if (roots.length > 1) {
        const mixinRoot = postcss.root();
        roots.forEach((root) => mixinRoot.prepend(...root.nodes));
        (0, stylable_utils_1.mergeRules)(mixinRoot, config.rule, mixDef.mixin.originDecl, config.transformer.diagnostics);
    }
}
function createMixinRootFromCSSResolve(context, config, resolvedClass) {
    const stVarOverride = context.evaluator.stVarOverride || {};
    const meta = context.meta;
    const mixDef = config.mixDef;
    const isRootMixin = resolvedClass.symbol.name === resolvedClass.meta.root;
    const mixinRoot = (0, rule_1.createSubsetAst)(resolvedClass.meta.ast, (resolvedClass.symbol._kind === 'class' ? '.' : '') + resolvedClass.symbol.name, undefined, isRootMixin);
    const namedArgs = mixDef.mixin.options;
    if (mixDef.mixin.partial) {
        filterPartialMixinDecl(meta, mixinRoot, Object.keys(namedArgs));
    }
    const resolvedArgs = (0, functions_1.resolveArgumentsValue)(namedArgs, config.transformer, context.meta, context.diagnostics, mixDef.mixin.originDecl, stVarOverride, config.path, config.cssPropertyMapping);
    const mixinMeta = resolvedClass.meta;
    const symbolName = isRootMixin && resolvedClass.meta !== meta ? 'default' : mixDef.mixin.type;
    config.transformer.transformAst(mixinRoot, mixinMeta, undefined, resolvedArgs, config.path.concat(symbolName + ' from ' + meta.source), true, resolvedClass.symbol.name);
    (0, stylable_assets_1.fixRelativeUrls)(mixinRoot, mixinMeta.source, meta.source);
    return mixinRoot;
}
/** we assume that mixinRoot is freshly created nodes from the ast */
function filterPartialMixinDecl(meta, mixinRoot, overrideKeys) {
    let regexp;
    const overrideSet = new Set(overrideKeys);
    let size;
    do {
        size = overrideSet.size;
        regexp = new RegExp(`value\\((\\s*${Array.from(overrideSet).join('\\s*)|(\\s*')}\\s*)\\)`);
        for (const { text, name } of Object.values(meta.getAllStVars())) {
            if (!overrideSet.has(name) && text.match(regexp)) {
                overrideSet.add(name);
            }
        }
    } while (overrideSet.size !== size);
    mixinRoot.walkDecls((decl) => {
        var _a;
        if (!decl.value.match(regexp)) {
            const parent = decl.parent;
            decl.remove();
            if (((_a = parent === null || parent === void 0 ? void 0 : parent.nodes) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                parent.remove();
            }
        }
    });
}
//# sourceMappingURL=st-mixin.js.map